var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navigation'),_c('router-view'),_c('div',{staticClass:"footer-copyright text-right py-3"},[_c('b-container',{attrs:{"fluid":""}},[_vm._v(" v"+_vm._s(_vm.version)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }